import { useCallback } from 'react'
import { useEnterpriseAccountResetPasswordMutation } from 'domains/public/api'
import { useStoreSessionToken } from 'api/utils/apollo/session/sessionToken.hooks'

interface ResetPassword {
  rawToken: string
  password: string
}

export const useEnterpriseAccountResetPassword = () => {
  const [triggerMutation, { data, loading, error }] = useEnterpriseAccountResetPasswordMutation()

  const resetPassword = useCallback(
    (args: ResetPassword) =>
      triggerMutation({
        variables: {
          ...args,
        },
      }),
    [triggerMutation]
  )

  const apiSuccess = Boolean(data)
  const token = data?.enterpriseAccountResetPassword?.accessToken.token
  const { completed } = useStoreSessionToken(token)

  return {
    resetPassword,
    apiSuccess: apiSuccess && completed,
    apiLoading: loading || (apiSuccess && !completed),
    apiError: error,
  }
}
